import script from "./MyProxy.vue?vue&type=script&setup=true&lang=js"
export * from "./MyProxy.vue?vue&type=script&setup=true&lang=js"

import "./MyProxy.vue?vue&type=style&index=0&id=03646a0d&lang=css"

const __exports__ = script;

export default __exports__